import Service from "../service";
// eslint-disable-next-line no-unused-vars

const UploadImageAPI = {
  uploadImage(data) {
    console.log("dataxxx", data);
    return Service.post(
      `/api/uploadImage`,
      { data: data },
      {
        headers: { Authorization: `Bearer ${data.token}` },
      }
    );
  },
};

export default UploadImageAPI;
